import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFire } from "@fortawesome/free-solid-svg-icons";

import streakAnimation from "../../../../assets/lottie/streak-fire.json";
import { useLanguage } from "../../../../context/LanguageProvider";
import FadeIn from "../../../../shared/components/animation/FadeIn";
import LottieView from "../../../../shared/components/animation/LottieView";
import useCountUp from "../../../../shared/hooks/useCountUp";
import { formatNumber } from "../../../../shared/utils/format";
import { LESSON_MESSAGES } from "../../messages";
import ContinueButton from "./ContinueButton";

interface StreakCompleteProps {
    streak?: number; // The new streak length in days
    onContinue: () => void;
}

// Shown after the lesson-complete screen when today's streak just increased
// (first lesson of the day)
const StreakComplete = ({ streak = 1, onContinue }: StreakCompleteProps) => {
    const { lang } = useLanguage();
    const animatedStreak = useCountUp(streak, 1000, 600);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-orange-50 via-white to-white px-6 py-10">
            {/* The flame keeps looping */}
            <LottieView animationData={streakAnimation} loop className="h-56 w-56 sm:h-72 sm:w-72" />

            <FadeIn delay={200} className="text-center">
                <div className="flex items-center justify-center gap-3 text-orange-500">
                    <FontAwesomeIcon icon={faFire} className="text-5xl" />
                    <span className="text-7xl font-extrabold">{formatNumber(animatedStreak, lang)}</span>
                </div>

                <h2 className="mt-3 text-4xl font-extrabold text-gray-900 sm:text-5xl">
                    {LESSON_MESSAGES.streakDays}
                </h2>

                <p className="mt-3 text-lg text-gray-500">{LESSON_MESSAGES.streakText}</p>
            </FadeIn>

            <FadeIn delay={900} className="mt-10 w-full max-w-md">
                <ContinueButton onClick={onContinue} colorClassName="bg-orange-500 hover:bg-orange-400" />
            </FadeIn>
        </div>
    );
};

export default StreakComplete;